// @flow
import React from "react"
import { sum, groupWith, equals } from "ramda"
import { Text } from "componentsStyled/Typography/Texts"
import { FieldTitle } from "componentsStyled/Typography/Titles"
import { Hr } from "componentsStyled/Typography/Other"
import { formatMoney } from "data/units/money/formatters"
import { Spread } from "componentsStyled/Layout/Flex"
import type { Discount } from "data/reservations/types"
import type { OriginalReservation, Accessory } from "data/reservations/types"
import type { ReservationPricingQueryInput } from "data/reservations/graphql/queries"
import { calculateDiscount } from "../helpers"

type Props = {
  accessories: Accessory[],
  totalPrice: number,
  fullPrice: number,
  prices: number[],
  discounts: Discount[],
  currency: string,
  originalReservation?: ?OriginalReservation,
  input?: ReservationPricingQueryInput,
  productGroupName: string,
}

const ReservationPricingDetail = ({
  accessories,
  totalPrice,
  fullPrice,
  prices,
  discounts,
  currency,
  originalReservation,
  productGroupName,
  input,
}: Props) => {
  const priceGroups = groupWith(equals, prices || [])

  return (
    <React.Fragment>
      <Text uppercase bold black>
        {originalReservation ? "Extension " : ""}Payment details
      </Text>
      <FieldTitle>{productGroupName}</FieldTitle>
      {priceGroups.map((g, i) => (
        <Spread key={i}>
          <Text>
            {formatMoney(g[0], false, currency)} {currency}
            &nbsp;x {g.length} day{g.length > 1 ? "s" : ""}
          </Text>
          <Text>
            {formatMoney(sum(g), true, currency)} {currency}
          </Text>
        </Spread>
      ))}
      <br />
      {accessories ?
        accessories.map((a, i) => {
          // $Ramda
          const accessoryPrices = groupWith(equals, a.prices || [])

          return (
            <div key={a.name}>
              <FieldTitle>{a.name}</FieldTitle>
              {accessoryPrices.map((p, j) => (
                <Spread key={a.name + j}>
                  <Text>
                    {formatMoney(p[0], false, currency)} {currency}
                    &nbsp;x {p.length} day{p.length > 1 ? "s" : ""}
                  </Text>
                  <Text>
                    {formatMoney(sum(p), true, currency)} {currency}
                  </Text>
                </Spread>
              ))}
              <br />
            </div>
          )
        })
        : ""
      }
      {discounts && discounts.length > 0
        ? <React.Fragment>
            <Hr />
            <Spread>
              <Text>
                Subtotal
              </Text>
              <Text>
                {formatMoney(fullPrice, true, currency)} {currency}
              </Text>
            </Spread>
          </React.Fragment>
        : ""
      }
      {discounts && discounts.length > 0
        ? discounts.map((discount, i) => {
          if (discount.limitDays && discount.limitDays < 0) { return "" }

          const subscriptionTypeDisplay = discount.type.charAt(0).toUpperCase() + discount.type.slice(1)

          return (
            <Spread key={i}>
              <Text>
                {subscriptionTypeDisplay} discount
              </Text>
              <Text>
                -
                {formatMoney(calculateDiscount(prices, discount, 0), true, currency)} {currency}
              </Text>
            </Spread>
          )
        })
        : ""
      }
      <br />
      <Spread>
        <Text uppercase bold black>
          Your Total
        </Text>
        <Text uppercase bold black>
          {formatMoney(totalPrice, true, currency)} {currency}
        </Text>
      </Spread>
    </React.Fragment>
  )
}

export default ReservationPricingDetail



// WEBPACK FOOTER //
// ./src/components/ReservationPricing/ReservationPricingDetail/index.js